<template>
  <div>
    <div
      class="profile-field__title"
      :class="{
        'profile-field__title--required': field.required,
      }"
    >
      Последние места работы
    </div>

    <div>
      <c-item
        v-for="(job, i) in localValue"
        :key="job.unique"
        :field="field"
        :value="job"
        :preview="preview"
        :editable="editable"
        :error="error && error.items[i]"
        :can-remove="true"
        :options="options"
        @remove="removeJob(job)"
      />
    </div>

    <div class="add-job">
      <c-button
        :icon="{ icon: 'plus', color: 'primary' }"
        label="Добавить место работы"
        :disabled="preview || !editable || hasEmpty"
        size="small"
        @click="addJob"
      />
    </div>

    <error-feedback v-if="error && error.common" :text="error && error.common" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import CButton from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";
import CItem from "./item";

import { SYSTEM_TYPES, FIELD_TYPE_RECENT_JOBS } from "@/domains/profile/constants/system-types";
import { formatList } from "../../utils";
import { formatJobModel, isEmptyJob, JobModel } from "./utils";

const fieldConfig = SYSTEM_TYPES[FIELD_TYPE_RECENT_JOBS];

export default {
  components: { CButton, CItem, ErrorFeedback },
  props: ["field", "value", "preview", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: [],
    };
  },

  computed: {
    ...mapGetters({
      dictionaries: "profile/getDictionaries",
    }),
    dictionaryCode() {
      return fieldConfig.dictionaryCode;
    },
    variants() {
      return this.dictionaries[this.dictionaryCode] || [];
    },
    options() {
      return formatList(this.variants);
    },
    hasEmpty() {
      return this.localValue.some(isEmptyJob);
    }
  },

  watch: {
    localValue: {
      handler() {
        this.updateValue();
      },
      deep: true,
    },
    value(v) {
      this.setData(v);
    },
  },

  async created() {
    await this.$store.dispatch("profile/getDictionary", { code: this.dictionaryCode });
    if (this.value) this.setData(this.value);
    if (!this.localValue.length  && this.field.required) this.addJob();
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      const { value: fieldValue } = value;

      const newItems = (fieldValue || {}).jobs || [];
      const currentItems = this.localValue.map(formatJobModel);

      if (JSON.stringify(newItems) !== JSON.stringify(currentItems)) {
        this.localValue = (newItems || []).map(JobModel);
      }

      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateValue() {
      const newValue = this.localValue.map(formatJobModel);
      this.$emit("input", {
        value: {
          jobs: newValue,
        },
      });

      if (this.inited) this.$emit("change");
    },
    addJob() {
      const model = JobModel();
      this.localValue.push(model);
    },
    removeJob(job) {
      this.localValue = this.localValue.filter((i) => i !== job);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-job {
}
</style>
